import { Alert, lucideIcons } from '@round/creatorbase-ui';

const { CircleAlert } = lucideIcons;

type Props = {
    message: string;
};

/** Whatever the form cannot show against a control: a lost client, a network failure, a stray 400. */
export const ErrorBanner = ({ message }: Props) => (
    <Alert variant="destructive">
        <CircleAlert />
        <Alert.Title>Could not create the request</Alert.Title>
        <Alert.Description>{message}</Alert.Description>
    </Alert>
);
